import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import {
  AccountingEntities,
} from "src/model/class/general classes/accounting-entities";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { AccountingService } from "src/service/accounting.service";
import { AlertService } from "src/service/alert.service";
import { NetworkService } from "src/service/network.service";
import {
  SelectionType,
} from "@swimlane/ngx-datatable";
import { TranslationService } from "src/service/translation.service";
import { GenericTableAnagraphTable } from "src/model/class/general classes/generic-table-anagraph-table";
import { FiltersType } from "src/components/shared-components/enum/enumFilters";
import { LoaderService } from "src/service/loader.service";
import { LoggerService } from "src/service/logger.service";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { iGenericTable } from "src/model/interface/iGeneric-table";
import { Column, TableInfo, ValueToChange } from "src/components/shared-components/class/general-classes/item-history";
import { ColumnTableType, HideShowColumn } from "src/components/shared-components/enum/enumTableHistory";
import moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";

@Component({
    selector: "app-accounting-entities-list",
    templateUrl: "./accounting-entities-list.component.html",
    styleUrls: ["./accounting-entities-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountingEntitiesListComponent
  extends GenericTableAnagraphTable
  implements OnInit, iEvent, iGenericTable, iTranslation {
  @Input("allowEdit") allowEdit: boolean = true;
  @Input("allowDelete") allowDelete: boolean = true;
  @Input("allowInsert") allowInsert: boolean = true;
  @Input("openInPopup") openInPopup: boolean = false;

  //#region Translation
  private _cityUpNumber: string = "cityUpNumber";
  private _dateLastPaymentAsString: string = "dateLastPaymentAsString";
  private _description: string = "description";
  private _dictionary: string = "dictionary.";
  private _nRoom: string = "nRoom";
  private _numCounters: string = "numCounters";
  private _owner: string = "owner";
  private _tenant: string = "tenant";
  private _unitCode: string = "unitCode";
  //#endregion

  private _numCounter: string = "numCounter";
  private _logContext: string = "Accounting-entities-list.component";

  private _translateSubscription: Subscription = null;
  private _accountingEntitiesSubscription: Subscription = null;
  private _networkServiceSubscription: Subscription = null;

  private _intervalTimer: number = 4000;

  private _accountingEntities: Array<AccountingEntities> =
    new Array<AccountingEntities>();

  public _eventSubscriptions: Array<Subscription> = null;

  public connectionType = ConnectionType;
  public currentConnectionType: ConnectionType = ConnectionType.NONE;
  public toolBarColor: string = "primary";

  public tableInfo: TableInfo = null;
  public selected: Array<any> = new Array<any>();

  constructor(
    private _accountingEntitiesService: AccountingService,
    private _alertService: AlertService,
    private _translateService: TranslateService,
    private _modalController: ModalController,
    private _networkService: NetworkService,
    private _translationService: TranslationService,
    private _loaderController: LoaderService,
    private _loggerService: LoggerService,
    private _eventService: EventService,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.tableInfo = StaticClass.createTableInfo("", false, SelectionType.multi, this.createArrayColumns(), false, true);
    this.tableInfo.IsListInitialized = false;
    this.tableInfo.RowHeight = "auto";

    this.subscribeEvents();
    this.loadTranslation();
    this.subscribeTranslationEvent();
    this.subscribeNetworkServiceData();
    this.subscribeAccountingEntititesService();

    this._accountingEntitiesService.Init();

    this.initFilterFields();
  }

  public OnChanges(): void {
    if (!this.CurrentObject) {
      this.selected = [];
    }
  }

  public ngOnDestroy(): void {
    this._translateSubscription?.unsubscribe();
    this._accountingEntitiesSubscription.unsubscribe();
    this._networkServiceSubscription.unsubscribe();

    this.unsubscribeEvents();
  }

  //#region Translation
  public loadTranslation(): void {
  }

  public subscribeTranslationEvent(): void {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();

        this.createItemHistoryDesktopList();
      }
    );
  }
  //#endregion

  //#region Subscribe to event-service observable
  public subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        if (this.openInPopup) {
          this._modalController.dismiss();
        }
      })
    );
  }

  public unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Exec filter
   * @param query
   */
  public onClickFilter(query: string): void {
    this._accountingEntitiesService.GetAccountingEntitites(query);
  }

  /**
   * Receives the selected item in the table and 
   * issues it to the form.
   * @param selected 
   */
  public selectionChanged(selected: any): void {
    this.selected = selected;
    this.changedSelected.emit(
      (selected as AccountingEntities[]).map((x) => x.id).join(",")
    );
  }

  /**
   * Reloads the data.
   * @param reload 
   */
  public reloadData(reload: string): void {
    this._accountingEntitiesService.reloadServiceData();
  }

  /**
   * Create the array containing the objects to show in the app view.
   */
  public createItemHistoryList(): void {
  }

  /**
   * Creates and returns the columns to pass to the table.
   */
  public createArrayColumns(): Column[] {
    let columns: Column[] = [];
    columns.push(StaticClass.createColumnObj(this._nRoom, this._nRoom, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._description, this._description, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._numCounter, this._numCounters, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._dateLastPaymentAsString, "lastPaymentDate", "", ColumnTableType.DATE, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj("nCityUP", this._cityUpNumber, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._unitCode, this._unitCode, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._owner, this._owner, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._tenant, this._tenant, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    return columns;
  }

  /**
   * Creates the table rows.
   */
  public createItemHistoryDesktopList(): void {
    this.tableInfo.List = [];
    let ValueToChange: ValueToChange[] = [];
    for (let i = 0; i < this._accountingEntities.length; i++) {
      ValueToChange.push(StaticClass.createValueToChange(this._dateLastPaymentAsString, i, this.getStringDate(this._accountingEntities[i].dateLastPayment)));
    }
    this.tableInfo.List = StaticClass.createArrayForTable(this._accountingEntities, ValueToChange);
  }

  /**
   * Closes the modal.
   */
  public onCloseModal(): void {
    this._loggerService.log(LogLevel.LOG_INFO, this._logContext, this._logContext, "onCloseModal()", "onCloseModal");
    this._modalController.dismiss();
  }

  /**
   * Returns the formatted date.
   * @param date 
   */
  private getStringDate(date: Date): string {
    let dateToString: string = this._translationService.formatDateTime(moment(date));
    return new Date(dateToString).toString() === new Date("01-01-0001 00:00:00").toString() ? "" : dateToString;
  }

  /**
   * Creates the array containing the filters to be used for queries.
   */
  private initFilterFields(): void {
    this.tableInfo.Filters = [];
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.text, "roomNumber", this._dictionary + this._nRoom, "", [], ""));
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.text, this._description, this._dictionary + this._description, "", [], ""));
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.number, this._numCounter, this._dictionary + this._numCounters, "", [], ""));
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.text, "numCityUp", this._dictionary + this._cityUpNumber, "", [], ""));
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.text, this._unitCode, this._dictionary + this._unitCode, "", [], ""));
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.text, this._owner, this._dictionary + this._owner, "", [], ""));
    this.tableInfo.Filters.push(StaticClass.createFilterObject(FiltersType.text, this._tenant, this._dictionary + this._tenant, "", [], ""));
  }

  private subscribeAccountingEntititesService(): void {
    var timer = setTimeout(() => {
      this.handleApiResponseError();
    }, this._intervalTimer);
    this._accountingEntitiesSubscription =
      this._accountingEntitiesService.accountingEntitiesList
        //We ignore the "null" emission when log-out is executed
        .pipe(
          filter((res) => res !== null),
          map((listAccountingEntities) => {
            return listAccountingEntities || [];
          })
        )
        .subscribe(
          async (listAccountingEntities: Array<AccountingEntities>) => {
            clearTimeout(timer);
            if (
              this._accountingEntitiesService
                .isErrorInGetAccountingEntitiesListAPIRequest
            ) {
              this.tableInfo.IsListInitialized = false;

              this.handlePeculiarApiResponseError();
            } else {
              clearTimeout(timer);
              this._accountingEntities = listAccountingEntities;
              this.createItemHistoryDesktopList();

              this.tableInfo.IsListInitialized = true;
              this.tableInfo.ShowErrorContent = false;
              await this._loaderController.dismissLoaderWaiting();
            }
          }
        );
  }

  private async handleApiResponseError(): Promise<void> {
    this.tableInfo.ShowErrorContent = true;
    await this._loaderController.dismissLoaderWaiting();
    await this._alertService.presentAlertSomethingWrong();
  }

  /**
   * Subscribe to the public Observable of "NetworkService", 
   * which emits each time the connection change of type/state. 
   * A local property is changed to reflect the new value.
   */
  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;

          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType
          );

          this._accountingEntities = [...this._accountingEntities];
        }
      );
  }

  /**
   * Handle errors in api call which require peculiar reactions from the page; 
   * this includes cases where the error is propagated through subject.error()
   */
  private async handlePeculiarApiResponseError(): Promise<void> {
    if (this._accountingEntitiesService.isErrorNotSupported) {
      this.tableInfo.IsFunctionalityNotImplemented = true;
      await this._loaderController.dismissLoaderWaiting();
    } else {
      this.handleApiResponseError();
    }
  }
}
